/* Phone swipe rows get small dots under them. Desktop layouts are left alone (dots hidden in CSS). */
(function () {
  function setup(row) {
    if (row.dataset.blDots) return;
    var items = Array.prototype.filter.call(row.children, function (el) { return el.nodeType === 1; });
    if (items.length < 2) return;
    row.dataset.blDots = '1';
    var dots = document.createElement('div');
    dots.className = 'bl-dots';
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () {
        row.scrollTo({ left: item.offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    row.insertAdjacentElement('afterend', dots);
    function update() {
      var start = row.scrollLeft, best = 0, bestD = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(item.offsetLeft - items[0].offsetLeft - start);
        if (d < bestD) { bestD = d; best = i; }
      });
      if (row.scrollWidth > row.clientWidth + 4 && row.scrollLeft + row.clientWidth >= row.scrollWidth - 4) best = items.length - 1;
      Array.prototype.forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    }
    row.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  function init() {
    document.querySelectorAll('.bl-reel__row, .bl-steps__grid, .bl-testi__quotes').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
